import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFaceIdFace: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFaceIdFace"><Path d="M5.5 18C9.86706 21.3333 14.1329 21.3333 18.5 18" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 5.5V12.5C12.5 13.6046 11.6046 14.5 10.5 14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 4.5V8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 4.5V8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFaceIdFace;
